import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconLogOut24 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 24 24"
    data-fill-none
  >
    <path
      d="M2.25 19V5C2.25 4.27065 2.53994 3.57139 3.05566 3.05566C3.57139 2.53994 4.27065 2.25 5 2.25H9C9.41421 2.25 9.75 2.58579 9.75 3C9.75 3.41421 9.41421 3.75 9 3.75H5C4.66848 3.75 4.35063 3.88179 4.11621 4.11621C3.88179 4.35063 3.75 4.66848 3.75 5V19C3.75 19.3315 3.88179 19.6494 4.11621 19.8838C4.35063 20.1182 4.66848 20.25 5 20.25H9C9.41421 20.25 9.75 20.5858 9.75 21C9.75 21.4142 9.41421 21.75 9 21.75H5C4.27065 21.75 3.57139 21.4601 3.05566 20.9443C2.53994 20.4286 2.25 19.7293 2.25 19Z"
      fill="currentColor"
    />
    <path
      d="M15.4697 6.46967C15.7626 6.17678 16.2373 6.17678 16.5302 6.46967L21.5302 11.4697C21.8231 11.7626 21.8231 12.2373 21.5302 12.5302L16.5302 17.5302C16.2373 17.8231 15.7626 17.8231 15.4697 17.5302C15.1768 17.2373 15.1768 16.7626 15.4697 16.4697L19.9394 11.9999L15.4697 7.53022C15.1768 7.23732 15.1768 6.76256 15.4697 6.46967Z"
      fill="currentColor"
    />
    <path
      d="M21 11.25C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75H9C8.58579 12.75 8.25 12.4142 8.25 12C8.25 11.5858 8.58579 11.25 9 11.25H21Z"
      fill="currentColor"
    />
  </SvgIcon>
));
IconLogOut24.displayName = 'IconLogOut24';
